import { FormattedMessage } from 'react-intl';

import { PortfolioAccordionSummary } from '../PortfolioAccordionSummary';
import { PortfolioAccordionSummaryMetric } from '../PortfolioAccordionSummaryMetric';

import { APPRECIATION_COLOR, PrivacyContextAwareMoneyValue } from '../../../common';

export interface AppreciationAccordionSummaryProps {
  allTimeAppreciation: number;
  className?: string;
}

export const AppreciationAccordionSummary = ({ allTimeAppreciation, className }: AppreciationAccordionSummaryProps) => {
  return (
    <PortfolioAccordionSummary
      className={className}
      color={APPRECIATION_COLOR}
      title={<FormattedMessage id="appreciation-returns" defaultMessage="Appreciation Returns" />}
    >
      <PortfolioAccordionSummaryMetric color={APPRECIATION_COLOR}>
        <PrivacyContextAwareMoneyValue value={allTimeAppreciation} length={4} />
      </PortfolioAccordionSummaryMetric>
    </PortfolioAccordionSummary>
  );
};
